import { render, staticRenderFns } from "./PlatformPayView.vue?vue&type=template&id=5ea4c82b&scoped=true"
import script from "./PlatformPayView.vue?vue&type=script&lang=js"
export * from "./PlatformPayView.vue?vue&type=script&lang=js"
import style0 from "./PlatformPayView.vue?vue&type=style&index=0&id=5ea4c82b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea4c82b",
  null
  
)

export default component.exports